module.exports = __webpack_public_path__ + "static/media/kt-services.c8f75d2b.jpg";